module.exports = __webpack_public_path__ + "img/Mat Sabu_3.a4ac1cd0.jpg";